export const DOMAIN = "https://service.howbir.com";
export const VERSION = "1.1.4";
